export const PartnerIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
    <circle cx="24" cy="24" r="24" fill="currentColor" fillOpacity="0.1" />
    <path
      d="M30 22H33C33.5304 22 34.0391 22.2107 34.4142 22.5858C34.7893 22.9609 35 23.4696 35 24V30C35 30.5304 34.7893 31.0391 34.4142 31.4142C34.0391 31.7893 33.5304 32 33 32H30"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 32H30V20C30 19.4696 29.7893 18.9609 29.4142 18.5858C29.0391 18.2107 28.5304 18 28 18H17C16.4696 18 15.9609 18.2107 15.5858 18.5858C15.2107 18.9609 15 19.4696 15 20V30C15 30.5304 14.7893 31.0391 14.4142 31.4142C14.0391 31.7893 13.5304 32 13 32ZM13 32C12.4696 32 11.9609 31.7893 11.5858 31.4142C11.2107 31.0391 11 30.5304 11 30V26C11 25.4696 11.2107 24.9609 11.5858 24.5858C11.9609 24.2107 12.4696 24 13 24H15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="19" cy="32" r="2" stroke="currentColor" strokeWidth="2" />
    <circle cx="27" cy="32" r="2" stroke="currentColor" strokeWidth="2" />
  </svg>
);
